module.exports = __webpack_public_path__ + "img/at.2f656881.svg";